<template>
  <div class="banner">
    <div class="btn-wrap">
      <div class="btn" v-if="status.showTest" @click="setVisible">
        <span>免费体验</span>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="btn" v-if="status.showApplyRecords" @click="setVisible">
        <span>申请记录</span>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="btn" v-if="status.showWorkbench" @click="setVisible">
        <span>进入工作台</span>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    setVisible () {
      this.$emit('setVisible')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 600px;
  background: url(~@/assets/img/ecology/banner.png) no-repeat center;
  .btn-wrap {
    position: absolute;
    bottom: 100px;
    left: calc(50% - 602px);
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 213px;
    height: 45px;
    border-radius: 4px;
    background: #2a54d1;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    cursor: pointer;

    .el-icon-arrow-right {
      font-size: 14px;
      margin-left: 10px;
    }

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
